// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"c8370bc1","129":"94f92097","170":"d32f4957","313":"267288f1","378":"04fe2449","453":"4bc5fb2e","499":"4a86d598","501":"fdc4272a","688":"c28910f8","702":"e82d2476","710":"31e1c98b"}[chunkId] + ".chunk.js";
};